<template>
  <div class="d-flex justify-content-center">
    <DisplayEmpty v-if="status===0 || status===null" :length="length" />
    <DisplayWaiting v-else-if="status<=2" :length="length" />
    <DisplayResult v-else-if="status===3" :result="result" />
  </div>
</template>
<script>
import DisplayEmpty from './DisplayEmpty.vue'
import DisplayWaiting from './DisplayWaiting.vue'
import DisplayResult from './DisplayResult.vue'

export default {
  name: 'Show1StNumbers',
  components: {
    DisplayEmpty,
    DisplayWaiting,
    DisplayResult
  },
  props: {
    length: {
      type: [Number, String],
      required: true
    },
    results: {
      type: [Object, String],
    },
    resultKey: {
      type: String
    },
    updateCode: {
      type: Number,
      default: null
    },
    startSpin: {
      type: String,
      default: null
    },
    startShow: {
      type: String,
      default: null
    },
    endTime: {
      type: String,
      default: null
    },
    slotCounting: {
      type: String,
      default: null
    },
    distance: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      setTimeout: null,
      setTimeoutSpinNumber: null,
      step: null
    }
  },
  watch: {
    updateCode() {
      console.log('update process numbers', this.updateCode, this.resultKey, this.slotCounting)
      this.process()
    }
  },
  computed: {
    status() {
      return this.step
    },
    result() {
      if (this.results) {
        return this.results[this.resultKey]
      }else{
        return null
      }
    }
  },
  methods: {
    process() {
      // console.log('xxx', this.results)
      // ยังไม่ถึงเวลาเริ่มหมุน
      if(this.$moment().isBefore(this.startSpin)) {
        this.step = 0
        console.log('Show 1st Numbers = 1', this.resultKey, this.step, this.startSpin)
        // ตั้งค่า timeout เพื่อคำนวนสถานะอีกรอบ
        let diff = this.$moment(this.startSpin).diff(this.$moment(), 'milliseconds')
        clearTimeout(this.setTimeout)
        this.setTimeout = setTimeout(() => {
          this.process()
        }, diff)
      }else
      // ถ้ารางวัลที่ 2 ยังไม่มี ให้หมุนต่อไป
      if(!this.results['prize_1st']) {
        this.step = 1
        console.log('Show 1st Numbers = 2', this.resultKey, this.step)
      }else
      // ยังไม่มีผลมา
      if(!this.result) {
        this.step = 1
        console.log('Show 1st Numbers = 3', this.resultKey, this.step)
      }else
      // ออกผลเสร็จหมดแล้ว
      if(this.$moment().isAfter(this.endTime)) {
        this.step = 3
        console.log('Show 1st Numbers = 4', this.resultKey, this.step)
      }else
      // กำลังหมุน
      if(this.$moment().isAfter(this.startSpin)) {
        this.step = 2
        console.log('Show 1st Numbers = 5', this.resultKey, this.step)
      }
    }
  },
  created() {
    //console.log('this.results', this.results)
  },
  mounted() {
    //this.process()
  },
  beforeDestroy() {
    clearTimeout(this.setTimeout)
  }
}
</script>
